import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input } from 'reactstrap'

import FileManagerComponent from '../../Components/Common/FileManagerComponent';

const FileManager = () => {
  document.title = "Transferencia de archivos | Siga ERP";





  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Archivos</h5>
                </CardHeader>
                <CardBody>
                  <FileManagerComponent />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default FileManager;